import React, {useEffect} from 'react';
import lozad from 'lozad';
import { Facility } from '../components/Facility'

export const About = () => {
  useEffect(() => {
    document.title = 'About Us'; // Set the title to "About" when this component mounts
  }, []);


  useEffect(() => {
    const observer = lozad(); // Initialize lozad
    observer.observe(); // Start observing
  }, []);

  return (
    <>
    <section className='about'>
      <div className='container py-5'>
        <div className='row justify-content-center align-items-center py-5'>
          <div className='col-lg-6' data-aos="fade-right" data-aos-duration="1000">
            <h3 className='f-24'>About Our Store</h3>
            <p className='f-16'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>

            <p className='f-16'>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>

            <p className='f-16'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
            <img data-src={'images/signature.png'} className='lozad' alt="signature" />
          </div>

          <div className='col-lg-6' data-aos="fade-left" data-aos-duration="1000">
             <div className='about-img'>
               <img data-src={'images/about.jpg'} className='lozad' alt='about image'/>
             </div>
          </div>
        </div>
      </div>
    </section>

     <Facility/>

    </>
  );
};